import { SelectControl } from '@wordpress/components'
import { useDispatch, useSelect } from '@wordpress/data'

const MetaSelect = ({ fieldName, options }) => {
  const metaFieldValue = useSelect(
    select => select('core/editor').getEditedPostAttribute('meta')[fieldName],
    []
  )

  const setMetaFieldValue = useDispatch('core/editor').editPost

  return (
    <SelectControl
      value={metaFieldValue}
      options={options}
      onChange={content => setMetaFieldValue({ meta: { [fieldName]: content } })}
    />
  )
}

export default MetaSelect
